import { Flash, Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminOrderService } from '@services/adminOrderService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminOrdersIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminOrderService',
        'languageService',
    ] as const;

    private table!: Table;
    private flash: Flash;

    constructor(
        instances: Instance,
        private adminOrderService: AdminOrderService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.flash = instances.flash;
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminOrderService,
            {
                entityKey: 'orders',
                fetchData: (params) =>
                    this.adminOrderService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'description',
                            this.languageService.translate('buttons.view'),
                        ];
                    },
                    click: this._showOrderDialog.bind(this),
                },
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (order) => {
                        this.adminOrderService
                            .editDialog(order, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }

    private _showOrderDialog(order: Objekt): void {
        const cleanOrder = order.denyKeys(['organization.', 'user.']);
        const orderText = JSON.stringify(cleanOrder).replace(/,"/g, ',<br>"');
        this.flash.addDefault(orderText, 0);
    }
}

export const adminOrdersIndexController = app.controller(
    'adminOrdersIndexController',
    AdminOrdersIndexController,
);
